import guaranteedAprContent from '@components/CreditCardContent/components/guaranteedAprContent'
import minimumGuaranteedCreditLimitContent from '@components/CreditCardContent/components/minimumGuaranteedCreditLimitContent'
import noMinimumGuaranteedCreditLimitContent from '@components/CreditCardContent/components/noMinimumGuaranteedCreditLimitContent'
import representativeAprContent from '@components/CreditCardContent/components/representativeAprContent'

import { ContentProps } from './Content.interface'

const getRewardsContent = ({ creditCard }: ContentProps) => {
    return [
        guaranteedAprContent({ creditCard }),
        representativeAprContent({ creditCard }),
        minimumGuaranteedCreditLimitContent({ creditCard }),
        noMinimumGuaranteedCreditLimitContent({
            creditCard,
        }),
    ]
}

export default getRewardsContent
